import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loginAsEmployee,
  loginAsOrganisation,
} from "../../redux/auth/authSlice";
import { postApi } from "../../api/api_instance";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URLS } from "../../api/apiUrls";

export const SessionLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // If using query params
  // If using route params (e.g., /switch/:token)
  const { token } = useParams();

  const handleValidateSwitchToken = async (token) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.VALIDATE_SWITCH_TOKEN,
        data: { token },
      });

      if (response.success) {
        dispatch(loginAsEmployee());
        toast.success(response.message);
        navigate("/dashboard");
      }
    } catch (error) {
      toast.error("Login failed. Please check your credentials and try again.");
      navigate("/login");
    }
  };

  useEffect(() => {
    // dispatch(setLoadingState(true));
    if (!token) {
      navigate("/login");
      return;
    }

    handleValidateSwitchToken(token);
  }, []);

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      <div className="lg:w-2/5 w-full flex flex-col items-center justify-center p-6 lg:p-12 bg-white">
        <div>
          <h4 className="text-xl font-semibold">
            Please wait, switching application...
          </h4>
        </div>
      </div>
    </div>
  );
};
